import React from 'react';
import {
	Content,
	Label,
	LinearGuageContainer,
	TableCellChart,
	TableCellGroup,
	TableCellGroupDiv,
	TableCellMax,
	TableCellMin,
	TableRow,
	ToggleButton,
} from './CategoryHierarchy.styles';

import { ApIcon } from '@alixpartners/ui-components';
import LinearGauge from '../LinearGuage/LinearGauge';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';

const CategoryHierarchy = props => {
	const {
		data,
		onExpand,
		onToggle,
		showToggleButton,
		isFirstTab,
		isChildOfExpanded = false,
	} = props;
	function formatNumber(value, decimalPlaces = 2) {
		return Number.isInteger(value) ? value.toString() : value.toFixed(0);
	}
	return (
		<>
			{data.map(items => {
				const {
					name,
					level,
					qmin: min,
					qmax: max,
					qmedian: median,
					clientTotalMarker: clientSpend,
					children,
					isExpanded,
					group,
					id,
					clientDirectMarker: clientSpendDirect,
					clientIndirectMarker: clientSpendIndirect,
					showFormattedSpend,
					hideGradient,
					hideChart,
					unit = '',
				} = items;
				const hasChildren = Array.isArray(children) && children.length > 0;
				const icon = isExpanded
					? 'baseline_keyboard_arrow_down'
					: 'baseline_keyboard_arrow_right';
				return (
					<React.Fragment key={id ? id : name}>
						<TableRow
							group={group}
							level={level}
							isFirstTab={isFirstTab}
							isChildOfExpanded={isChildOfExpanded}
						>
							<TableCellGroup>
								<TableCellGroupDiv
									level={level}
									isFirstTab={isFirstTab}
									hasChildren={hasChildren}
								>
									{showToggleButton && (
										<ToggleButton
											onClick={
												hasChildren
													? () => onToggle(level, name, group, isExpanded)
													: () => onExpand(group, level, name, items)
											}
										>
											<ApIcon iconName={icon} iconColor="black" />
										</ToggleButton>
									)}
									<Label>
										{' '}
										{name.endsWith('Term')
											? `${name} (Days)`
											: name == 'Touchless PO'
												? `${name} (%)`
												: name == 'Indirect spend'
													? `Actively managed indirect spend`
													: name}{' '}
									</Label>
								</TableCellGroupDiv>
							</TableCellGroup>

							<TableCellMin>
								<Content>
									<Label> </Label>
								</Content>
							</TableCellMin>
							<TableCellMin>
								<Content>
									<Label>
										{!hideChart && showFormattedSpend
											? formatSpendWithDecimalAndSymbol(
													min,
													'$',
													true
											  )?.toUpperCase()
											: (min || min === 0) && `${formatNumber(min)}${unit}`}
									</Label>
								</Content>
							</TableCellMin>
							<TableCellChart>
								<LinearGuageContainer>
									{!hideChart && (
										<LinearGauge
											values={{
												group,
												level,
												min,
												max,
												median,
												clientSpend,
												showFormattedSpend,
												clientSpendDirect,
												clientSpendIndirect,
												hideGradient,
												unit,
											}}
										/>
									)}
								</LinearGuageContainer>
							</TableCellChart>
							<TableCellMax>
								<Content>
									<Label>
										{!hideChart && showFormattedSpend
											? formatSpendWithDecimalAndSymbol(
													max,
													'$',
													true
											  )?.toUpperCase()
											: (max || max === 0) && `${formatNumber(max)}${unit}`}
									</Label>
								</Content>
							</TableCellMax>
						</TableRow>
						{isExpanded && (
							<>
								{hasChildren &&
									children.map(child => (
										<CategoryHierarchy
											key={Math.random()}
											data={[child]}
											onExpand={onExpand}
											onToggle={onToggle}
											showToggleButton={showToggleButton}
											isFirstTab={isFirstTab}
											isChildOfExpanded={true}
										/>
									))}
							</>
						)}
					</React.Fragment>
				);
			})}
		</>
	);
};

export default CategoryHierarchy;
